module.exports = __webpack_public_path__ + "static/img/logo-natal.ae4babf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-natal.png
// module id = 7zAy
// module chunks = 1